import { render, staticRenderFns } from "./view-mother.vue?vue&type=template&id=0a7a4c99&scoped=true&"
import script from "./view-mother.vue?vue&type=script&lang=js&"
export * from "./view-mother.vue?vue&type=script&lang=js&"
import style0 from "./view-mother.vue?vue&type=style&index=0&id=0a7a4c99&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7a4c99",
  null
  
)

export default component.exports